import React from "react";
import { Tbody, Td, Tr } from "@chakra-ui/table";
import { Skeleton } from "@chakra-ui/react";

const Body = ({
  pages,
  prepareRow,
  getTableBodyProps,
  isLoading,
  nbColumns,
}) => {
  return (
    <Tbody {...getTableBodyProps()}>
      <LoadingWrapper isLoading={isLoading} nbColumns={nbColumns}>
        {pages.map((row, rIdx) => {
          prepareRow(row);
          return (
            <Tr key={rIdx} {...row.getRowProps()}>
              {row.cells.map((cell, cIdx) => {
                return (
                  <Td
                    key={cIdx}
                    {...cell.getCellProps()}
                    isNumeric={cell.column.isNumeric}
                  >
                    {cell.render("Cell")}
                  </Td>
                );
              })}
            </Tr>
          );
        })}
      </LoadingWrapper>
    </Tbody>
  );
};

export default Body;
const LoadingWrapper = ({ isLoading, children, nbColumns }) => {
  if (isLoading) {
    return Array(10)
      .fill("")
      .map((_, index) => (
        <Tr key={index}>
          {Array(nbColumns)
            .fill("")
            .map((_, colIndex) => (
              <Td key={colIndex}>
                <Skeleton height="20px" />
              </Td>
            ))}
        </Tr>
      ));
  } else return children;
};
